var map = {
	"./Group.svg": 6794,
	"./chat-icon.svg": 4711,
	"./facebook-icon.svg": 6533,
	"./global-icon.svg": 9614,
	"./job-icon.svg": 1252,
	"./linkedin-icon.svg": 7859,
	"./mail-icon.svg": 8978,
	"./map-pin-range-fill.svg": 9627,
	"./map-pin-range-line.svg": 1510,
	"./point-icon.svg": 7665,
	"./send-plane-fill.svg": 8972,
	"./tel-icon.svg": 8746,
	"./wechat-2-line.svg": 9837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;